import script from "./ExpenseList.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpenseList.vue?vue&type=script&setup=true&lang=js"

import "./ExpenseList.vue?vue&type=style&index=0&id=f3ff2684&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3ff2684"]])

export default __exports__